<template>
  <ModalComponent class="first-unit-created-alert" :show="show" clickaway>
    <Card variant="default">
      <template #header>
        <div class="card-v2__title">{{ $t('firstUnitCreatedTitle') }}</div>

        <div
          class="card-v2__subtitle"
          v-html="
            $t('firstUnitCreatedSubtitle', {
              link: `<a href='https://help.kvass.no/nb/articles/14449'>${$t('here').toLowerCase()}</a>`,
            })
          "
        ></div>
      </template>

      <template #thumbnail>
        <Icon icon="fa-pro-light:party-horn" />
      </template>
      <template #actions>
        <ButtonComponent
          :label="$t('gotoOverview')"
          :icon="['fal', 'arrow-right']"
          @click="$emit('update:show', false)"
        />
        <ButtonComponent
          tag="a"
          theme="primary"
          :href="value.url"
          target="_blank"
          :label="`${$t('preview')} ${$t('thisUnit').toLowerCase()}`"
          :icon="['fal', 'external-link']"
        />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import Card from '@/components/Card-v2'
import { ModalComponent } from 'vue-elder-modal'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
    },
  },
  computed: {},
  components: {
    Card,
    ModalComponent,
  },
}
</script>

<style lang="scss">
.first-unit-created-alert {
  .card-v2 {
    max-width: 600px;
  }
  .card-v2__thumbnail {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--dark-green);
    background: var(--light-green);
    aspect-ratio: 16 / 7;

    .kvass-icon {
      $size: 8rem;
      height: $size;
      width: $size;
    }
  }
}
</style>
